"use strict";

(function ($) {
    var init = false;

    $(document).ready(initMenuMobile);

    $(window).resize(initMenuMobile);

    function initMenuMobile()
    {
        if (!init) {
            $('.menu-item.menu-item-has-children').click(function () {
                if ($(document).width() < 768) {
                    var menu = $(this);
                    if (menu.hasClass('active')) {
                        menu.find('.sub-menu').hide('slow', function () {
                            menu.removeClass('active');
                        });
                    } else {
                        menu.addClass('active');
                        menu.find('.sub-menu').show('slow');
                    }
                }
            });
            init = true;
        }
    }
})(jQuery);